import { render, staticRenderFns } from "./newPlanUpload.vue?vue&type=template&id=31bc1b40"
import script from "./newPlanUpload.vue?vue&type=script&lang=js"
export * from "./newPlanUpload.vue?vue&type=script&lang=js"
import style0 from "./newPlanUpload.vue?vue&type=style&index=0&id=31bc1b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports